import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash-es';

@Injectable()

@Pipe({
    name: 'orderByNumber', pure: false,
    standalone: true
})

export class OrderByNumber implements PipeTransform {
  // array - array
  // config - parameter
  // order - asc / desc

  transform<T>(array: T[], params: keyof T | Array<keyof T>, order?: 'asc' | 'desc' | boolean): T[] {
    const paramArray = Array.isArray(params) ? params : [params];
    array = _.map(array, function(item) {
      _.each(paramArray, function(param: keyof T) {
        (item as any)[param] = Number(item[param]);
      });
      return item;
    });
    return _.orderBy(array, paramArray as any, order as any);
  }
}
